import React from "react";
import { Box, Button } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const OrderActionButtons = ({ receiptUrl }) => (
  <Box
    display="flex"
    justifyContent="flex-end"
    gap={2}
    mt={2}
    className="no-print">
    {receiptUrl && (
      <Button
        variant="outlined"
        endIcon={<OpenInNewIcon />}
        onClick={() => window.open(receiptUrl, "_blank")}>
        View Receipt
      </Button>
    )}
    <Button
      variant="outlined"
      onClick={() => window.print()}
      endIcon={<PrintIcon />}>
      Print Order
    </Button>
  </Box>
);

export default OrderActionButtons;
